var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list.length >= _vm.visibleAdjusted && (_vm.max ? _vm.list.length < _vm.max : true))?_c('div',{class:_vm.$style.loadMoreButton,on:{"click":_vm.showMore}},[_c('span',[_vm._v("Load more")]),_c('BaseIcon',{class:[_vm.$style.icon, _vm.$style.iconArrowDown],attrs:{"name":"arrow-long-down"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }